<template>
  <div class="min-w-0">
    <span class="sr-only">
      {{ i18n(translations.emittedFromAssistant) }}
    </span>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '../ShoppingAssistant.translations'

const i18n = useI18n()
</script>
